import Toast from '../Toast';
import { ApiResponse, PaginatedApiResponse, axios } from '../config/axios';
import config from '../config/config';

export const BooksService = {
  async all({ per_page, page, search }: any): Promise<PaginatedApiResponse<any>> {
    return await axios.get('/books', {
      params: {
        per_page,
        page,
        search,
      },
    });
  },
  async allNoPagination(): Promise<ApiResponse<any>> {
    return await axios.get('/books/all');
  },
  async one(id: number | string): Promise<ApiResponse<any>> {
    return await axios.get(`/books/${id}`);
  },
  async create(data: FormData) {
    try {
      const response = await axios.post(`${config.baseUrl}/books`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async update(id: number | string, data: FormData) {
    try {
      const response = await axios.patch(`${config.baseUrl}/books/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
  async delete(id: number) {
    try {
      const response = await axios.delete(`${config.baseUrl}/books/${id}`);
      return response;
    } catch (error: any) {
      console.log('Error', error);
      Toast.error(error?.response?.data?.message);
    }
  },
};

export default BooksService;
